import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../client";
import imageUrlBuilder from "@sanity/image-url";
import Loading from "./Loading";
import BlockContent from "@sanity/block-content-to-react";

const builder = imageUrlBuilder(sanityClient);
const urlFor = (source) => {
  return builder.image(source);
};

const SinglePost = () => {
  const [singlePost, setSinglePost] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == "${slug}"]{
      title,
      _id,
      slug,
      mainImage{
        asset-> {
          _id,
          url
        }
      },
      body,
      "name": author->name,
      "authorImage": author->image
    }`
      )
      .then((data) => setSinglePost(data[0]))
      .catch((error) => console.log(error));
  }, [slug]);

  if (!singlePost) return <Loading />;
  return (
    <main className="singlepost fade-in">
      <article className="singlepost__article">
        <header>
          <div className="header__div">
            <div className="singlepost__title">
              <h1>{singlePost.title} </h1>
              <div className="singlepost__info">
                <img
                  src={urlFor(singlePost.authorImage).url()}
                  alt={singlePost.name}
                  height="50"
                />
                <p>{singlePost.name}</p>
              </div>
            </div>
          </div>
          <img
            src={singlePost.mainImage.asset.url}
            alt={singlePost.title}
            className="bg-img"
          />
        </header>
        <div className="singlepost__content">
          <BlockContent
            blocks={singlePost.body}
            projectId="9d8kgobr"
            dataset="production"
          />
        </div>
      </article>
    </main>
  );
};

export default SinglePost;
